import Vue from 'vue';
import Cookie from './cookie.vue';

const cookie = new Vue({
    components:{
        'ws-cookie':Cookie,
    }
}).$mount('#cookie');